import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { CookieModule } from 'ngx-cookie';
import { UserService } from './shared/services/user.service';
import { SessionService } from './shared/services/session.service';
import { CommonDataService } from './shared/services/common-data.service';
import { SystemService } from './shared/services/system.service';
import { ConfigService } from './config/config.service';
import { httpExtensionService } from './shared/services/httpextension.service';

import { AuthorizationGuard } from './shared/guards/authorization.guard';

import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { HeaderComponent } from './shared/header/header.component';
import {ConfirmationService, MessagesModule, ConfirmDialogModule} from 'primeng/primeng';
import { SettingsService } from './shared/services/settings.service';
import { OrdersService } from './shared/services/orders.service';
import {AddEditOrdersComponent} from "./orders/add-edit-orders/add-edit-orders.component";
import {MembersService} from "./shared/services/members.service";
import {EmployeesService} from "./shared/services/employees.service";
import {SortablejsModule} from "angular-sortablejs";
// import { FundraisersOrderUpdateComponent } from './fundraisers/fundraisers-orders/fundraisers-order-update.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        SidebarComponent,
        HeaderComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        ReactiveFormsModule,
        routing,
        CookieModule.forRoot(),
        MessagesModule,
        ConfirmDialogModule,
        SortablejsModule
    ],
    providers: [
        UserService,
        ConfigService,
        SessionService,
        SettingsService,
        CommonDataService,
        SystemService,
        AuthorizationGuard,
        httpExtensionService,
        OrdersService,
        AddEditOrdersComponent,
        MembersService,
        ConfirmationService,
        EmployeesService,
        // FundraisersOrderUpdateComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts